import { cleanEnv, str } from 'envalid';

// Vite exposes env vars on import.meta.env
const rawEnv = import.meta.env;

const env = cleanEnv(rawEnv, {
  VITE_STRIPE_PUBLISHABLE_KEY: str({ default: '' }),
  VITE_STRIPE_ACCOUNT_ID: str({ default: '' }),
});

/**
 * Stripe Elements credentials for the in-site checkout.
 *
 * Both values are needed together. Recurly's payment gateway is a Stripe *Connect* account, so
 * Elements has to be loaded with the account id as well as the publishable key - a live key against
 * a test account (or the reverse) fails at confirmation with "your request was in live mode, but
 * used a known test card".
 *
 * There is no tenancy switch here, unlike ecommerce. nano-site has no tenancy concept, so each
 * deploy carries exactly one key/account pair, set per stack in `cdk/stacks/NanoSiteStack.ts`. The
 * pair must belong to the same Recurly site that `VITE_API_HOST` points at.
 */
export const stripeConfig = {
  publishableKey: env.VITE_STRIPE_PUBLISHABLE_KEY,
  accountId: env.VITE_STRIPE_ACCOUNT_ID,
};

/**
 * False when either value is missing, which is the case in local dev until both are set. Call sites
 * gate the payment UI on this rather than rendering an Elements tree that can never confirm.
 */
export function isStripeConfigured(): boolean {
  return !!stripeConfig.publishableKey && !!stripeConfig.accountId;
}
